import { Spin, message } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import { useParams } from "react-router-dom";
import MonixModal from "@/commons/widget/monix-modal";
import { User } from "@/commons/interface/project/user";
import { getUsers } from "@/api/project/user";
import { USER_TYPE } from "@/commons/enums/user";

interface IProps {
    fillterList: string[]
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (values: string[]) => void
}

export default function LinkProjectUserModal(props: IProps) {
    const { projectId } = useParams();
    const [users, setUsers] = useState<User[]>([]); // 可选中的用户
    const [selected, setSelected] = useState<string[]>([]); // 选中的用户id
    const [loading, setLoading] = useState<boolean>(false); // 加载loading

    useEffect(() => {
        if (!props.visible) {
            // setSelected([]);
            setLoading(false);
            setUsers([]);
        }
    }, [props.visible])

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // 按下确认按钮
    const onSaveClick = () => {
        if (selected?.length === 0) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    // 获取可选择数据
    const generateData = () => {
        setLoading(true);
        setSelected(props.fillterList)
        getUsers().then(res => {
            if (res.status === 200) {
                let data: User[] = res.data || [];
                data = data?.filter(item => item.type != USER_TYPE.ADMIN) || [];
                setUsers(data);
            }
        }).catch(err => {
            message.error("获取用户失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"添加项目用户"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={!props.visible}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={loading}>
                <div className="link-body">
                    {users?.map((item: User, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => {
                                let idx = selected?.findIndex(g => g === item.uuid);
                                setSelected(prev => {
                                    if (idx === -1) {
                                        prev.push(item.uuid);
                                    } else {
                                        prev.splice(idx, 1);
                                    }
                                    return [...prev];
                                })
                            }}>
                                {!selected?.some(g => g === item.uuid) && <CheckSvg />}
                                {selected?.some(g => g === item.uuid) && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`名称：${item?.name || ''}`}</div>
                        </div>
                    ))}
                </div>
            </Spin>
        </MonixModal>
    )
}